import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  textAlign: 'center',
  fontSize: '28px',
  color: '#383838',
};

export const sxTypographySubTitle: SxProps = {
  fontFamily: 'Unimed-Sans',
  textAlign: 'center',
  color: '#4C4C4C',
};

export const sxButton: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  color: 'rgb(0,0,0,0.08)',
  border: '2px solid #00995D',
  '@media (max-width: 999px)': {
    width: 'stretch',
  },
  '&:focus': {
    background: '#fff'
  }
};

export const sxButtonContained: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  '@media (max-width: 999px)': {
    width: 'stretch',
  },
};


export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16,
  color: '#00995D',
};

export const sxCloseIconButton: SxProps = {
  position: 'absolute',
  right: '16px',
  top: '16px',
  color: '#383838',
  '@media(max-width: 650px)': {
    right: '16px',
    top: '12px'
  }
}